import { Injectable } from '@angular/core';
import { addIcons } from 'ionicons';

import {
  library,
  playCircle,
  radio,
  search,
  arrowForwardOutline,
  printOutline,
  arrowBackOutline,
  discOutline,
  exitOutline,
  cardOutline,
  peopleOutline,
  personCircleOutline,
  heartCircle,
  createOutline,
  arrowForwardCircleOutline,
  chevronDownOutline,
  chevronCollapse,
  chevronForward,
  chevronForwardCircleSharp,
  addOutline,
  filterOutline,
  closeOutline,
  businessOutline,
  personAddOutline,
  closeCircle,
  closeCircleOutline,
  personOutline,
  arrowDownOutline,
  arrowUpOutline,
  womanOutline,
  locationOutline,
  gridOutline,
  manOutline,
  cashOutline,
  albumsOutline,
  homeOutline,
  calendarOutline,
  informationCircleOutline,
  ellipsisHorizontal,
  ellipsisVerticalCircle,
  ellipseOutline,
  ellipsisHorizontalCircleOutline,
  ellipsisVertical,
  ellipsisVerticalOutline,
  ellipsisVerticalCircleOutline,
  warningOutline,
  arrowForward,
  warning,
  removeCircle,
  removeOutline,
  pricetags,
  downloadOutline,
  pricetagOutline,
  pricetagsOutline,
  logOutOutline,
  chevronForwardOutline,
  checkmarkCircleOutline,
  documentOutline,
  checkmarkOutline,
  receiptOutline,
  walletOutline,
  trashOutline,
  sendOutline,
  archiveOutline,
  analyticsOutline,
  refreshCircleOutline,
  swapHorizontalOutline,
  returnUpForwardOutline,
  eyeOffOutline,
  eyeOutline,
  pencilOutline,
  openOutline,
  expandOutline,
} from 'ionicons/icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor() {}
  async initIcons() {
    addIcons({
      cardOutline,
      receiptOutline,
      trashOutline,
      createOutline,
      openOutline,
      logOutOutline,
      swapHorizontalOutline,
      cashOutline,
      locationOutline,
      refreshCircleOutline,
      checkmarkCircleOutline,
      checkmarkOutline,
      downloadOutline,
      pencilOutline,
      sendOutline,
      archiveOutline,
      library,
      analyticsOutline,
      walletOutline,
      removeCircle,
      peopleOutline,
      expandOutline,
      removeOutline,
      chevronForwardOutline,
      pricetags,
      pricetagOutline,
      pricetagsOutline,
      closeCircle,
      arrowForwardCircleOutline,
      closeCircleOutline,
      arrowForward,
      gridOutline,
      documentOutline,
      ellipsisHorizontal,
      warningOutline,
      warning,
      eyeOffOutline,
      eyeOutline,
      ellipsisVerticalCircle,
      ellipseOutline,
      ellipsisHorizontalCircleOutline,
      ellipsisVertical,
      ellipsisVerticalOutline,
      ellipsisVerticalCircleOutline,
      manOutline,
      arrowDownOutline,
      albumsOutline,
      homeOutline,
      arrowUpOutline,
      womanOutline,
      calendarOutline,
      businessOutline,
      personAddOutline,
      personOutline,
      playCircle,
      radio,
      closeOutline,
      filterOutline,
      search,
      arrowForwardOutline,
      printOutline,
      arrowBackOutline,
      discOutline,
      exitOutline,
      personCircleOutline,
      heartCircle,
      chevronDownOutline,
      chevronCollapse,
      chevronForward,
      returnUpForwardOutline,
      informationCircleOutline,
      chevronForwardCircleSharp,
      addOutline,
    });
  }
}
